export default __webpack_public_path__ + "static/media/about-gaming.67d82a57.jpg";